export const ReplaceEmailPhoneWithLink = content => {
  /// Regular expression to match phone numbers and email addresses
  const contactInfoRegex = /\b(\d{3}[-.\s]??\d{3}[-.\s]??\d{4}|\(\d{3}\)[-\s]??\d{3}[-.\s]??\d{4}|\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b)\b/g

  // Replace phone numbers and emails with tel/mailto links if not already wrapped in an anchor tag
  const updatedContent = content?.replace(contactInfoRegex, function(match) {
    if (!/<a.*?>.*?<\/a>/i.test(match)) {
      // If the match is not already wrapped in an anchor tag
      if (/^\d{3}[-.\s]??\d{3}[-.\s]??\d{4}$/.test(match)) {
        // Phone number
        return `<a href="tel:${match}">${match}</a>`
      } else if (
        /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/.test(match)
      ) {
        // Email address
        return `<a href="mailto:${match}">${match}</a>`
      }
    }
    return match
  })

  return updatedContent
}
